import { render, staticRenderFns } from "./VehicleOrderCenter.vue?vue&type=template&id=618f7314&scoped=true&"
import script from "./VehicleOrderCenter.vue?vue&type=script&lang=js&"
export * from "./VehicleOrderCenter.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOrderCenter.vue?vue&type=style&index=0&id=618f7314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f7314",
  null
  
)

export default component.exports